import { PanelComponentKeyType } from "config/panelConfig";
import { restoreCamera } from "@features/analysis/rendering/Panels/Renderers/CornerstoneManager";
import { Series } from "@models/Series";

export function calculateRRPercent(
  selectedSeries:Series|undefined,
): number {
  if(!selectedSeries) return 0;
  const seriesDescription = selectedSeries?.seriesDescription;
  const imageComments = selectedSeries?.imageTag.imageComment;
  const scanOptions = selectedSeries?.imageTag.scanOptions;
  console.group('calculateRRPercent');
  console.log('seriesDescription',seriesDescription);
  console.log('imageComments',imageComments);
  console.log('scanOptions',scanOptions);
  console.groupEnd()
  const clampPercent = (value: number) => Math.min(100, Math.max(0, value));
  const parseSinglePercent = (text?: any): number | null => {
    if (!text) return null;
    // % 범위 있는녀석인데 그 사이에 뛰어쓰기가 심한녀석때문에 예외처리
    const isRange =
      /\d+(?:\.\d+)?\s*%?\s*-\s*\d+(?:\.\d+)?\s*%/.test(text);
    if (isRange) return null;
    const percentMatch = text.match(/(\d+(?:\.\d+)?)\s*%/);
    if (!percentMatch) return null;
    //단일로 있는 퍼센트만 있을경우
    const parsed = parseFloat(percentMatch[1]);
    return Number.isNaN(parsed) ? null : clampPercent(parsed);
  };
  let heartBpm: number | null = null;
  let phaseMs: number | null = null;
  let rrInterval: number | null = null;
  //Series Description
  const seriesPercent = parseSinglePercent(seriesDescription);
  if (seriesPercent !== null) return seriesPercent;
  //imageComments
  if (imageComments) {
    const imagePercent = parseSinglePercent(imageComments);
    if (imagePercent !== null) return imagePercent;
    const hrMatch = imageComments.match(/(\d+)\s*bpm/i);
    if (hrMatch) heartBpm = parseInt(hrMatch[1], 10);
    const msMatches = [...imageComments.matchAll(/(-?\d+)\s*ms/gi)];
    if (msMatches.length > 0) {
      phaseMs = parseInt(msMatches[0][1], 10);
      for (const match of msMatches) {
        const value = parseInt(match[1], 10);
        if (value < 0) {
          phaseMs = value;
          break;
        }
      }
    }
  }
  // Scan Options
  if (scanOptions) {
    const percentMatch = scanOptions.match(/TP(\d+(?:\.\d+)?)PC(\d+)/i);
    if (percentMatch) {
      const parsed = parseFloat(percentMatch[1]);
      if (!Number.isNaN(parsed)) return clampPercent(parsed);
    }
    const tpMatch = scanOptions.match(/TP(\d+)MS(\d+)/i);
    if (tpMatch) {
      phaseMs = parseInt(tpMatch[1], 10);
      if(!heartBpm){
        //이 경우에는 순수 scanOptions 값으로 계산
        // heartBpm = 60000 / interval;
        rrInterval = parseInt(tpMatch[2], 10);
      }
    }
  }
  // RR interval 계산 (HR 기반)
  if (!rrInterval && heartBpm) {
    rrInterval = 60000 / heartBpm;
  }
  if (!phaseMs || !rrInterval) return 0;
  // 음수 ms 보정
  if (phaseMs < 0) {
    phaseMs = rrInterval - Math.abs(phaseMs);
  }
  const rrPercent = Math.round((phaseMs / rrInterval) * 100);
  return clampPercent(rrPercent);
}

export function updateOtherViews(
  componentKey:string[],
){
  //아니 왜 swapLayoutPanelConfig 하면 안바뀐 dicomPanel zoom 바뀌는 이유가 모르겠네
  //임시로 안바뀐 viewID를 다시 카메라 셋팅해서 사용하는걸로 넣어놔....
  const result = ["Axial", "Coronal", "Sagittal"].filter(
    v => !componentKey
          .some(k => k?.toLowerCase() === v.toLowerCase())
  );
  for (const key of result) {
    restoreCamera(key as PanelComponentKeyType);
  }
}
